/* eslint-disable complexity, no-invalid-this */
export class DOM {
    static queryAll(el, selector) {
        if (typeof el === 'string') {
            selector = el;
            el = document;
        }
        const elements = el.querySelectorAll(selector);
        return Array.prototype.slice.call(elements);
    }

    static ready(callback) {
        if (document.readyState !== 'loading') {
            callback();
        } else {
            document.addEventListener('DOMContentLoaded', callback);
        }
    }

    static html(template) {
        const tmp = document.implementation.createHTMLDocument('');
        tmp.body.innerHTML = template;
        return tmp.body.children;
    }

    static hasClass(el, className) {
        if (el.classList) {
            return el.classList.contains(className);
        }
        return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);

    }

    static addClass(el, className) {
        if (el.classList) {
            el.classList.add(className);
        } else {
            el.className += ' ' + className;
        }
    }

    static remClass(el, className) {
        if (el.classList) {
            el.classList.remove(className);
        } else {
            el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    }

    static removeClass(element, className) {
        let hasClass = this.hasClass(element, className);
        if (hasClass) {
            let reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
            element.className = element.className.replace(reg, ' ');
        }
    }

    static matches(el, selector) {
        return (el.matches || el.matchesSelector || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector || el.oMatchesSelector).call(el, selector);
    }

    static delegate(el, evt, sel, handler) {
        const self = this;
        el.addEventListener(evt, function (event) {
            let t = event.target;
            while (t && t !== this) {
                if (self.matches(t, sel)) {
                    handler.call(t, event);
                }
                t = t.parentNode;
            }
        });
    }

    static serialize(obj) {
        let str = [];

        if (typeof obj !== 'object' || Array.isArray(obj)) {
            return 'false';
        }

        for (let p in obj) {
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
            }
        }

        return str.join('&');
    }
}



// WEBPACK FOOTER //
// /src/common/browser.js